import { jsx } from '@emotion/core';
import { COLORS } from '../../constants';
import { Input } from './input';
import { WithButton } from './withbutton';
import { TextArea } from './textarea';
import { Icon } from '../Icon';
import { Label } from '../shared';
import { ErrorField } from '../shared';
import { Prefix, Suffix } from './addon';
import { Wrapper } from './wrapper';
import { forwardRef } from 'react';
var iconStyles = {
  position: 'absolute',
  top: '50%',
  left: '12px',
  transform: 'translateY(-50%)'
};
/**
 * The following is a hacky way to add "static" properties to a type that we don't conrol
 * ie. the ForwardRefExoticComponent type
 */

function appendCompoundComponents(input) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  var fullInput = input;
  fullInput.WithButton = WithButton;
  fullInput.TextArea = TextArea;
  return input;
}

var InputField = appendCompoundComponents(forwardRef(function (_a, ref) {
  var errorMessage = _a.errorMessage,
      label = _a.label,
      icon = _a.icon,
      prefix = _a.prefix,
      suffix = _a.suffix,
      onChange = _a.onChange,
      onFocus = _a.onFocus,
      onBlur = _a.onBlur,
      onEnterPress = _a.onEnterPress,
      size = _a.size,
      className = _a.className,
      value = _a.value,
      placeholder = _a.placeholder,
      id = _a.id,
      name = _a.name,
      disabled = _a.disabled,
      type = _a.type,
      autoFocus = _a.autoFocus;
  var isValid = !errorMessage;
  return jsx(Label, {
    isValid: isValid,
    className: className
  }, label, jsx(Wrapper, null, prefix && jsx(Prefix, {
    size: size,
    hasLabel: !!label
  }, prefix), icon && jsx(Icon, {
    css: iconStyles,
    color: value ? COLORS.grays.darkest : COLORS.grays.gray,
    content: icon
  }), jsx(Input, {
    className: className,
    errorMessage: errorMessage,
    label: label,
    icon: icon,
    prefix: prefix,
    suffix: suffix,
    onChange: onChange,
    onFocus: onFocus,
    onBlur: onBlur,
    onEnterPress: onEnterPress,
    size: size,
    value: value,
    placeholder: placeholder,
    id: id,
    name: name,
    disabled: disabled,
    type: type,
    autoFocus: autoFocus,
    ref: ref
  }), suffix && jsx(Suffix, {
    size: size,
    hasLabel: !!label
  }, suffix)), !isValid && jsx(ErrorField, null, errorMessage));
}));
export default InputField;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@trustpilot/businessapp-patternlibrary/lib/components/Input/index.js
// module id = 201
// module chunks = 0